import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './components/menu/menu.component';
import { AppRoutingModule } from '../app-routing.module';
import { FeatureComponent } from './components/feature/feature.component';
import { FooterComponent } from './components/footer/footer.component';
import {  HttpClientModule } from '@angular/common/http';
import { UploadComponent } from './components/upload/upload.component';
import { JobPostsFilterPipe } from './pipes/job-posts-filter.pipe';
import { ModalComponent } from './components/modal/modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PagerComponent } from './components/pager/pager.component';
import { NavigationDropdownComponent } from './components/navigation-dropdown/navigation-dropdown.component';
import { RouterModule } from '@angular/router';
import { AppModalComponent } from './components/app-modal/app-modal.component';
import { DomSanitizePipe } from './pipes/dom-sanitize.pipe';
import { FormatlinkPipe } from './pipes/formatlink.pipe';
import { SortByPipe } from './pipes/sort-by.pipe';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageCropperComponent } from './components/image-cropper/image-cropper.component';
import { ReviewComponent } from './components/review/review.component';
import { DisplayReviewComponent } from './components/display-review/display-review.component';
import { ImagePathPipe } from './pipes/image-path.pipe';
import { UserNotificationsComponent } from './components/user-notifications/user-notifications.component';
import { HumanizeDatePipe } from './pipes/humanize-date.pipe';
import { ReportAsMaliciousComponent } from './components/report-as-malicious/report-as-malicious.component';

@NgModule({
    declarations: [MenuComponent, FeatureComponent, FooterComponent, UploadComponent, JobPostsFilterPipe, ModalComponent, PagerComponent, NavigationDropdownComponent, AppModalComponent, DomSanitizePipe, FormatlinkPipe, SortByPipe, ImageCropperComponent, ReviewComponent, DisplayReviewComponent, ImagePathPipe, UserNotificationsComponent, HumanizeDatePipe, ReportAsMaliciousComponent],
    exports: [MenuComponent, FeatureComponent, FooterComponent, UploadComponent, JobPostsFilterPipe, ModalComponent, PagerComponent, NavigationDropdownComponent, AppModalComponent, DomSanitizePipe, FormatlinkPipe, SortByPipe, ImageCropperComponent, ReviewComponent, DisplayReviewComponent, ImagePathPipe, UserNotificationsComponent, HumanizeDatePipe, ReportAsMaliciousComponent],
  imports: [
    RouterModule,
    NgbModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    ImageCropperModule,
    FormsModule,
    ReactiveFormsModule
  ],
  entryComponents: [ModalComponent]
})
export class SharedModule { }
